import { render } from "./NewsFeature.vue?vue&type=template&id=13814078&scoped=true"
import script from "./NewsFeature.vue?vue&type=script&lang=js"
export * from "./NewsFeature.vue?vue&type=script&lang=js"

import "./NewsFeature.vue?vue&type=style&index=0&id=13814078&lang=less&scoped=true"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13814078"]])

export default __exports__